import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = { class: "grey-form-card" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Male")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Female")
const _hoisted_6 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_InfoIcon = _resolveComponent("InfoIcon")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_form = _resolveComponent("el-form")
  const _component_LeavePreventPopup = _resolveComponent("LeavePreventPopup")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "label-position": "top",
      "label-width": "100px",
      model: _ctx.form,
      rules: _ctx.rules,
      ref: "subjectForm"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "Subject ID",
            prop: "subject_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.subject_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.subject_id = $event)),
                maxlength: 30,
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trim('subject_id')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.hasRole(_ctx.UserRole.SystemAdmin))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Site",
                prop: "site_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown, {
                    class: "input-dropdown",
                    trigger: "click"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DropdownFilter, {
                            class: "form-dropdown-filter",
                            filterData: _ctx.state.sites
                          }, null, 8, ["filterData"])
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { disabled: _ctx.isEdit }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.site) + " ", 1),
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { class: "parent-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "half-part-item radio-form-item",
                prop: "sex_type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.form.sex_type,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.sex_type = $event)),
                    label: "M"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { class: "half-part-item radio-form-item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    modelValue: _ctx.form.sex_type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.sex_type = $event)),
                    label: "F"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Year of Birth",
            prop: "year_of_birth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.form.year_of_birth,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.year_of_birth = $event)),
                type: "year",
                "clear-icon": "",
                "default-value": _ctx.middleDate,
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trim('year_of_birth')))
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Language",
            prop: "language",
            class: "languageItem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.language,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.language = $event)),
                placeholder: "-"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languageList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.code,
                      label: item.description,
                      value: item.code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                content: "Assessment language - editable only via the GT Diagnostics Web Portal.",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InfoIcon)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Comment",
            prop: "comment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.comment,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.comment = $event)),
                maxlength: 500,
                onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.trim('comment')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode("div", _hoisted_6, [
      _createVNode("button", {
        class: "button secondary",
        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.cancel()), ["prevent"]))
      }, " Cancel "),
      _withDirectives(_createVNode("button", {
        class: "button",
        disabled: !_ctx.isRequiredFilled,
        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"]))
      }, " Save ", 8, ["disabled"]), [
        [
          _directive_loading,
          _ctx.state.loading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_LeavePreventPopup, {
      form: _ctx.form,
      disabled: _ctx.state.isSubmitted
    }, null, 8, ["form", "disabled"])
  ]))
}